export enum Errors {
    NO_VOTES = 'no_votes',
    TOO_MANY_VOTES = 'too_many_votes',
    TOO_MANY_PLUS_VOTES = 'too_many_plus_votes',
    TOO_MANY_MINUS_VOTES = 'too_many_minus_votes',
    RULE_2_1_BROKEN = 'rule_2_1_broken',
}
